(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name tracking.factory:TrackingRequestFactory
     *
     * @description
     *
     */
    angular
        .module('tracking')
        .factory('TrackingRequestFactory', TrackingRequestFactory);

    function TrackingRequestFactory() {

        var getFleetSearchRequest = function (searchParam) {
            return {
                fromDate: searchParam.fromDate,
                toDate: searchParam.toDate,
                baseAirport: (searchParam.crewBase && searchParam.crewBase.airPortCode) || '',
                airport: (searchParam.airport && searchParam.airport.airPortCode) || '',
                viewOption: searchParam.viewOption,
                flightNumber : searchParam.flightNumber || '',
                crewTypeCode : searchParam.crewType && searchParam.crewType.crewTypeCode || '',
                timeZone: searchParam.timeZone,
                aircraftModel: (searchParam.aircraftModel && searchParam.aircraftModel.modelNumber) || ''
            };
        };

        var getAircraftListRequest = function () {
            return {
                modelNumber: '',
                pageSize: 200,
                startPosition: 0
            };
        };

        var getTrackingSuggestionRequest = function (params) {
            return {
                descrepency: params.descrepency,
                patternId: params.patternId,
                crewTypes: params.crewType || [],
                genders: params.gender || [],
                languageCodes: params.languageCode || []
            };
        };

        var getTrackingUnassignedRequest = function (params) {
            return {
                blankDaysOnly: true,
                patternId: params.patternId,
                crewTypes: params.crewType || [],
                genders: params.gender || [],
                languageCodes: params.languageCode || []
            };
        };

        var getUnAssignCrewRequest = function (param) {
            var request = {
                unAssignColl: [{
                    crewProfileId: param.crewProfileId,
                    crewSchdBlockId: param.crewScheduleBlockId
                }]
            };
            return request;
        };

        var getAssignPatternRequest = function (crewProfileId, patternId, flags) {
            return {
                crewProfileId: crewProfileId,
                patternId: patternId,
                request: flags && flags.isRequest,
                calledFromDayOff: flags && flags.isCallFromDayOff,
                continueIllegal: flags && flags.isContinueIllegal,
                userConfirm: flags && flags.isUserConfirm
            };
        };

        var getSwapRequest = function (firstCrew, secondCrew, flags) {
            var getList = function (crewOne, crewTwo, isAssignList) {
                var resultList = [];
                if (!!isAssignList) {
                    resultList.push({
                        crewProfileId: crewOne.crewProfileId,
                        crewScheduleBlockId: crewTwo.currCrewSchdBlockId,
                        crewType: crewOne.crewTypeCode
                    });
                    resultList.push({
                        crewProfileId: crewTwo.crewProfileId,
                        crewScheduleBlockId: crewOne.crewScheduleBlockId,
                        crewType: crewTwo.crewType
                    });
                } else {//Unassign List
                    angular.forEach([crewOne, crewTwo], function (crew) {
                        resultList.push({
                            crewProfileId: crew.crewProfileId,
                            crewScheduleBlockId: crew.crewScheduleBlockId || crew.currCrewSchdBlockId,
                            crewType: crew.crewTypeCode || crew.crewType
                        });
                    });
                }
                return resultList;
            };

            return {
                assignList: getList(firstCrew, secondCrew, true),//SwapDTO
                unAssignList: getList(firstCrew, secondCrew, false),//SwapDTO
                userConfirm: flags.isUserConfirm,
                ignoreExpiry: flags.isIgnoreExpiry
            };
        };

        var getAllDiscrepancyRequest = function (flightLegId) {
            return {
                flightLegId : flightLegId || ''
            };
        };


        return {
            assignPatternRequest: getAssignPatternRequest,
            allDiscrepancyRequest: getAllDiscrepancyRequest,
            fleetSearchRequest: getFleetSearchRequest,
            aircraftListRequest: getAircraftListRequest,
            swapRequest: getSwapRequest,
            trackingSuggestionRequest: getTrackingSuggestionRequest,
            unAssignCrewRequest: getUnAssignCrewRequest,
            getTrackingUnassignedRequest: getTrackingUnassignedRequest
        };
    }
}());
